package com.eladfinish.bible.contest.screens.chapterComplete.features.progressiveExposure

internal object ProgressiveExposureNormalizer {

    fun normalize(
        text: String,
    ): String {
        return text
            .replace("  ", " ")
            // Keep trailing '\n' if present; trim only spaces/tabs.
            .trimEnd { ch ->
                ch == ' ' || ch == '\t'
            }
    }
}
